import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExternalLink } from "@fortawesome/pro-regular-svg-icons";

export const ExternalLinkIcon = () => {
  return <FontAwesomeIcon transform="right-4" icon={faExternalLink} color={"var(--primary-light-blue)"}/>;
};
